import React, { useState, useEffect, useMemo } from 'react'
import { Switch, Route, Redirect, Router } from 'react-router-dom'
import Dashboard from 'bxl-dashboard'
import ProtectedRouteBuilder from './modules/protectedRoute'
import NotFound from './pages/notfound'
import Login from './modules/session'
import './App.scss'
import PageList from './pages/PageList'
import Lego from './pages/Lego/Lego'
import Material from './pages/material'
import MaterialList from './pages/materialList'
import Playground from './pages/playground'
import bxlUtils from 'bxl-utils'
import './i18n'
import { useTranslation } from 'react-i18next'
import Title from './components/title'
import HeaderDropdown from './components/HeaderDropdown'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import enGb from 'antd/lib/locale/en_GB'
import history from '@/router'
import { isSigned, getUserName, signOut } from '@/utils/session'
import legoService from './services/lego'
import { connect } from 'react-redux'
import { setBaseData } from '@/store/actions/baseData'

const mapDispatchToProps = dispatch => ({
  setBaseData: data => {
    dispatch(setBaseData(data))
  },
})

const antdLanguageList = {
  en: enGb,
  zh: zhCN,
}

const PrivateRoute = ProtectedRouteBuilder(isSigned, '/login')

const App = ({ setBaseData }) => {
  const { t, i18n } = useTranslation()
  const [username, setUsername] = useState(getUserName() || 'UnKnown')
  const [language, setLanguage] = useState(i18n.language?.includes('zh') ? 'zh' : 'en')
  useEffect(() => {
    const unlisten = history.listen(() => {
      setUsername(getUserName() || 'UnKnown')
    })

    return () => {
      unlisten()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language, i18n])

  const routeList = useMemo(() => {
    return [
      {
        id: 'lego',
        name: t('pageConstruction'),
        icon: 'WindowsOutlined',
      },
      {
        id: 'page-list',
        pid: 'lego',
        route: '/lego/list',
        name: t('pageList'),
      },
      {
        id: 'material',
        name: '创意工厂',
        icon: 'FormOutlined',
      },
      {
        pid: 'material',
        id: 'material-editor',
        name: '素材编辑',
        route: '/material/editor',
      },
      {
        pid: 'material',
        id: 'material-list',
        name: '素材列表',
        route: '/material/list',
      },
      {
        id: 'playground',
        route: '/playground',
        name: 'Playground',
        icon: 'PlaySquareOutlined',
      },
    ]
  }, [t])

  const onLanguageChange = (language: string) => {
    setLanguage(language)
  }

  useEffect(() => {
    legoService
      .getBaseInfo()
      .then(res => {
        console.log(res.data)
        setBaseData(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  return (
    <ConfigProvider locale={antdLanguageList[language]}>
      <Router history={history}>
        <div className="App">
          <Dashboard
            isMobile={bxlUtils.platform.isAndroid() || bxlUtils.platform.isIOS()}
            username={username}
            name="Lego"
            avatar="https://baleen-cdn-g.bybieyang.com/static/images/admin/default_avatar.png"
            routeList={routeList}
            onSignOut={() => {
              signOut()
            }}
            title={
              <Title>
                <HeaderDropdown language={language} onLanguageChange={onLanguageChange} />
              </Title>
            }
          >
            <Switch>
              <PrivateRoute exact path="/lego/list" component={PageList} />
              <PrivateRoute exact path="/lego/edit/:id" component={Lego} />
              <PrivateRoute exact path="/lego/edit" component={Lego} />
              <PrivateRoute exact path="/material/editor/:id?/:type?" component={Material} />
              <PrivateRoute exact path="/material/list" component={MaterialList} />
              <Route path="/login" component={Login} />
              <Route path="/playground" component={Playground} />
              <Redirect from="/" to="/lego/list" />
              <Route exact path="/404" component={NotFound} />
            </Switch>
          </Dashboard>
        </div>
      </Router>
    </ConfigProvider>
  )
}

export default connect(null, mapDispatchToProps)(App)
